import { IconComponent } from '@/components/IconComponent';
import {
  ScArrow,
  ScArrows,
  ScProgressIndicator,
  ScProgressTrack,
  ScSliderControls,
} from '@/modules/vip/ComparisonSection/components/ComparisonSlider/styled';

interface ISliderControlsProps {
  canNext: boolean;
  canPrev: boolean;
  onNext: () => void;
  onPrev: () => void;
  currentIndex: number;
  totalSlides: number;
  slidesPerView: number;
}

export const SliderControls = ({
  canNext,
  canPrev,
  onNext,
  onPrev,
  currentIndex,
  totalSlides,
  slidesPerView,
}: ISliderControlsProps) => {
  const effectiveTotal = totalSlides - slidesPerView + 1;

  return (
    <ScSliderControls>
      <ScProgressTrack $steps={effectiveTotal}>
        <ScProgressIndicator $step={currentIndex} $steps={effectiveTotal} />
      </ScProgressTrack>
      <ScArrows>
        <ScArrow
          $disabled={!canPrev}
          $flipped
          disabled={!canPrev}
          onClick={onPrev}
          type="button"
        >
          <IconComponent name="whiteArrowRight" size="24px" />
        </ScArrow>
        <ScArrow
          $disabled={!canNext}
          disabled={!canNext}
          onClick={onNext}
          type="button"
        >
          <IconComponent name="whiteArrowRight" size="24px" />
        </ScArrow>
      </ScArrows>
    </ScSliderControls>
  );
};
